import { useEffect } from 'react';
import { Box, Button, Grid, Typography, useTheme } from '@mui/material';

import { useHistory } from 'react-router';
import { HOTELS } from '@shared/helpers/routes';
import { useSelector } from 'react-redux';
import { ERROR_COPY } from '@shared/constants/bookingErrors';
import { sxStyle } from './styles';
import { DEFAULT_ERROR, HEADER_MESSAGES } from './constants';

const resolveValue = (value, context) =>
  typeof value === 'function' ? value(context) : value;

const Cabecera = ({
  datos,
  codeLoc,
  code,
  email,
  pagos,
  bookingStatus,
  showBookingDetails,
}) => {
  const theme = useTheme();
  const history = useHistory();
  const { id } = useSelector(store => store.pageConfiguration);

  const errorType = datos?.errorType;
  const isSucursal = +id === 2;

  const errorCopy = ERROR_COPY[errorType] ?? DEFAULT_ERROR;

  const operationType = pagos ? 'PAYMENT' : 'BOOKING';

  const siteType = isSucursal ? 'GIT' : 'TDH';

  // DEFAULT_ERROR es el fallback para un bookingStatus no mapeado en
  // HEADER_MESSAGES; es distinto de BOOKING_STATUS.FAILED, que sí está
  // mapeado y usa el copy dinámico de ERROR_COPY según errorType.
  const message =
    HEADER_MESSAGES[operationType][bookingStatus] ?? DEFAULT_ERROR;

  const Icon = message?.icon;

  const context = {
    errorCopy,
    isSucursal,
    site: siteType,
  };

  useEffect(() => {
    document
      .getElementById('exitoContainerId')
      ?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }, []);

  return (
    <Box sx={sxStyle.container}>
      <Grid
        container
        justifyContent="center"
        alignItems="center"
        id="exitoContainerId"
        sx={{
          ...sxStyle.grid,
          ...(!showBookingDetails && { mb: '32px' }),
        }}
      >
        <Box sx={sxStyle.content}>
          {Icon && (
            <Box sx={{ ...sxStyle.badgeWrapper, ...message.badgeStyle }}>
              <Icon sx={message.iconStyle} />
            </Box>
          )}

          <Typography sx={sxStyle.title}>
            {resolveValue(message.title, context)}
          </Typography>

          {message.subtitle && (
            <Typography component="p" sx={sxStyle.subtitle}>
              {resolveValue(message.subtitle, context)}
            </Typography>
          )}

          {message.showBookingData && (
            <>
              <Box sx={sxStyle.infoBox}>
                <Typography sx={sxStyle.infoText}>
                  Código de reserva
                  <Typography component="span" sx={sxStyle.highlightText}>
                    {code}
                  </Typography>
                  <Typography component="span" sx={sxStyle.infoSeparator}>
                    ·
                  </Typography>
                  Código de localizador
                  <Typography component="span" sx={sxStyle.highlightText}>
                    {codeLoc}
                  </Typography>
                </Typography>
              </Box>

              <Typography sx={{ mt: 1 }}>
                Te enviamos la confirmación a {email}
              </Typography>
            </>
          )}

          {message.showNewSearch && (
            <Button
              variant="outlined"
              onClick={() => history.push(HOTELS)}
              sx={sxStyle.buttonOutline(theme)}
            >
              Nueva Búsqueda
            </Button>
          )}
        </Box>
      </Grid>
    </Box>
  );
};

export default Cabecera;
